{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "CS2 Jackpot",
  "alternateName": [
    "рулетка кс го", "рулетки кс 2", "кс 2 рулетка", "рулетка скинами кс го",
    "скины кс го рулетка", "рулетка скинов", "сайт рулетка кс го",
    "рулетка кс 2", "csgo рулетка", "jackpot cs go"
  ],
  "description": "Jackpot – азартная игра, где игроки вносят скины и случайный победитель получает весь банк.",
  "url": "https://6cs.fail/ru/jackpot"
}
